import { createContext } from 'react';

import { Page } from 'types/models/Page';

export type PageContextType = Page | Record<string, never>;

export const PageContext = createContext<PageContextType>({});
